module.exports = __webpack_public_path__ + "data_collect.png";